/**
 * Attachment rules, widget-side.
 *
 * Deliberately duplicated from `libs/support-chat/src/attachments.ts` rather
 * than imported: that module lives in the server package, and importing it
 * here would drag the NestJS/TypeORM graph into a browser bundle. This
 * package has no dependencies beyond React, which is what lets it drop into
 * both frontends unchanged.
 *
 * The SERVER copy is authoritative — it decides what actually gets linked to
 * a conversation. This copy exists so the widget can reject an obvious
 * mistake before spending an upload. Keep the two in sync.
 */

export const ALLOWED_ATTACHMENT_EXTENSIONS = [
  "pdf",
  "doc",
  "docx",
  "jpg",
  "jpeg",
  "png",
] as const;

export const ATTACHMENT_ACCEPT = ".pdf,.doc,.docx,.jpg,.jpeg,.png";
export const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024; // 10 MB
export const MAX_ATTACHMENTS_PER_MESSAGE = 5;

export function attachmentExtension(fileName: string): string {
  const dot = fileName.lastIndexOf(".");
  return dot === -1 ? "" : fileName.slice(dot + 1).toLowerCase();
}

export function isAllowedAttachment(fileName: string): boolean {
  return (ALLOWED_ATTACHMENT_EXTENSIONS as readonly string[]).includes(
    attachmentExtension(fileName),
  );
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
